<custom-menu position="footer" [horizontal]="true"></custom-menu>

<div class="social"></div>

<div class="copyright">
    {{ 'Copyright' | trans }} © {{ settings.get('branding.site_name') }} {{year()}}
</div>